import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        departments: '<',
        roles: '<',
        levels: '<',
        planningGroup: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'courses.Add target' | translate }}</h2>
        </div>
        <div class="modal-body">
            <form-wrapper form="vm.form">
                <form-row error="vm.form.errors.targets">
                    <span ng-bind-html="vm.form.errors.targets"></span>
                </form-row>
                <div class="form">
                    <div class="row separated">
                        <label class="label">{{ 'courses.Department' | translate }}</label>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                ng-if="vm.FilterService.toggleDepartment"
                                options="vm.FilterService.departmentSelect.options"
                                selected-model="vm.FilterService.departmentSelect.models"
                                extra-settings="vm.FilterService.departmentSelect.settings"
                                events="vm.FilterService.departmentSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                            <div ng-dropdown-multiselect=""
                                ng-if="!vm.FilterService.toggleDepartment"
                                options="vm.FilterService.departmentSelect.options"
                                selected-model="vm.FilterService.departmentSelect.models"
                                extra-settings="vm.FilterService.departmentSelect.settings"
                                events="vm.FilterService.departmentSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        </div>
                    </div>
                    <div class="row separated">
                        <label class="label">{{ 'courses.Role' | translate }}</label>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                ng-if="vm.FilterService.toggleRole"
                                options="vm.FilterService.roleSelect.options"
                                selected-model="vm.FilterService.roleSelect.models"
                                extra-settings="vm.FilterService.roleSelect.settings"
                                events="vm.FilterService.roleSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                            <div ng-dropdown-multiselect=""
                                ng-if="!vm.FilterService.toggleRole"
                                options="vm.FilterService.roleSelect.options"
                                selected-model="vm.FilterService.roleSelect.models"
                                extra-settings="vm.FilterService.roleSelect.settings"
                                events="vm.FilterService.roleSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        </div>
                    </div>
                    <div class="row separated">
                        <label class="label">{{ 'courses.Level' | translate }}</label>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                ng-if="vm.FilterService.toggleLevel"
                                options="vm.FilterService.levelSelect.options"
                                selected-model="vm.FilterService.levelSelect.models"
                                extra-settings="vm.FilterService.levelSelect.settings"
                                events="vm.FilterService.levelSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                            <div ng-dropdown-multiselect=""
                                ng-if="!vm.FilterService.toggleLevel"
                                options="vm.FilterService.levelSelect.options"
                                selected-model="vm.FilterService.levelSelect.models"
                                extra-settings="vm.FilterService.levelSelect.settings"
                                events="vm.FilterService.levelSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        </div>
                    </div>
                </div>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor (lodash, FormFactory, FilterService) {
        this.lodash = lodash;
        this.FormFactory = FormFactory;
        this.FilterService = FilterService;
    }

    $onInit () {
        this.createForm();
        this.initMultiSelects();
    }

    initMultiSelects () {
        this.FilterService.setDepartments(this.departments);
        this.FilterService.setRoles(this.roles);
        this.FilterService.setLevels(this.levels);
        this.FilterService.initClassifierMultiFilter();
    }

    /**
     * Resets form drls to db state
     */
    resetFormTargets () {
        this.form.model.targets = angular.copy(this.planningGroup.planningGroupTargetsWithValue);
    }

    createForm () {
        this.form = this.FormFactory.create(this.planningGroup, model => model.$update({ id: model.id }));

        this.resetFormTargets();
    }

    beforeSave () {
        this.resetFormTargets();

        const departmentTargetId = this.lodash.get(this.FilterService.departmentSelect.models, '0.id', null);
        const roleTargetId = this.lodash.get(this.FilterService.roleSelect.models, '0.id', null);
        const levelTargetId = this.lodash.get(this.FilterService.levelSelect.models, '0.id', null);

        if (this.FilterService.departmentSelect.models.length > 1) {
            this.lodash.forEach(this.FilterService.departmentSelect.models, department => {
                this.addTarget(department.id, roleTargetId, levelTargetId);
            });
        }
        else if (this.FilterService.roleSelect.models.length > 1) {
            this.lodash.forEach(this.FilterService.roleSelect.models, role => {
                this.addTarget(departmentTargetId, role.id, levelTargetId);
            });
        }
        else {
            this.lodash.forEach(this.FilterService.levelSelect.models, level => {
                this.addTarget(departmentTargetId, roleTargetId, level.id);
            });
        }
    }

    addTarget (department, role, level) {
        this.form.model.targets.push({
            id: null,
            departmentId: department,
            roleId: role,
            levelId: level,
            type: this.form.model.type
        });
    }

    save () {
        this.beforeSave();
        this.form.save().then(() => this.uibModalInstance.close());
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/planningGroup/target/add-deprecated/index.js